import React, { useState } from 'react'

import { Dropdown } from 'semantic-ui-react'

import { getHeroData, getHeroImage } from 'draft/heroes/useHeroes'
import { GameType, Hero } from 'draft/types'

type Props = {
    heroName: string,
    gameType: GameType,
    team : 'blue' | 'red'
    onChange: (heroName: string) => void
}

const HeroSelect = ({ heroName, team, gameType, onChange }: Props) => {
    const [selectedHero, setSelectedHero] = useState(heroName);
    let options: any = [];

    const heroList: any = getHeroData(gameType);
    const heroListCopy = Object.assign({}, getHeroData(gameType));
    for (var key in heroListCopy) {
        var hero: Hero = heroList[key];
        let name = hero.Name;
        options.push({
            key: key,
            value: name,
            text: name,
            image: { src: getHeroImage(gameType, hero) },
        })
    }

    const handleChange = (e:any, data:any) => {
        let hero : string;

        // On enter click
        if(data.vlaue !== ''){
          hero = data.value;
        }else{
            hero = e.target.innerText;
        }

        setSelectedHero(hero)
        onChange(hero);
    }

    return (
        <Dropdown
            style={{
                minWidth: '230px',
                textAlign: 'left',
                background: '#051122',
                color: '#fff',
                border: `1px solid ${team === 'blue' ? '#db2828' : '#2185d0'}`,
                
            }}
            placeholder='Select Hero'
            search
            selection
            options={options}
            onChange={(e,data) => handleChange(e,data)}
            value={selectedHero}
        />
    )
}

export default HeroSelect;